import { useEffect } from "react";

import { setMute } from "../store/audio-slice";
import { useAppDispatch } from "../store/hooks";

export const useMuteAudio = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const visibilityListener = (): void => {
      dispatch(setMute(document.visibilityState !== "visible"));
    };
    window.addEventListener("visibilitychange", visibilityListener);
    return () =>
      window.removeEventListener("visibilitychange", visibilityListener);
  }, [dispatch]);
};
